module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-radiobox",
    staticStyle: {
      "margin-top": "45px"
    }
  }, [_c('div', [_c('mt-box-group', {
    attrs: {
      "max": 3
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  }, [_c('mt-cell-group', {
    attrs: {
      "title": "普通单选"
    }
  }, [_vm._l((_vm.options2), function(item) {
    return _c('mt-radiobox', {
      key: item.value,
      attrs: {
        "name": item.value,
        "disabled": item.disabled
      },
      on: {
        "click": _vm.blank
      }
    }, [_vm._v("\n                  " + _vm._s(item.label) + "\n              ")])
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "选中的项"
    }
  }, [_vm._v(_vm._s(_vm.value1))])], 2)], 1)], 1), _vm._v(" "), _c('div', [_c('mt-box-group', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  }, [_c('mt-cell-group', {
    attrs: {
      "title": "全部禁用"
    }
  }, _vm._l((_vm.options2), function(item) {
    return _c('mt-radiobox', {
      key: item.value,
      attrs: {
        "name": item.value
      }
    }, [_vm._v("\n                  " + _vm._s(item.label) + "\n              ")])
  }))], 1)], 1), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "mint-box-group-title"
  }, [_vm._v("右对齐")]), _vm._v(" "), _c('mt-box-group', {
    attrs: {
      "disabled": false,
      "align": "right"
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  }, [_c('mt-cell-group', _vm._l((_vm.options2), function(item) {
    return _c('mt-radiobox', {
      key: item.value,
      attrs: {
        "align": "right",
        "name": item.value,
        "disabled": item.disabled,
        "iconpattern": "hook"
      }
    }, [_vm._v("\n                  " + _vm._s(item.label) + "\n              ")])
  }))], 1)], 1), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "mint-box-group-title"
  }, [_vm._v("组合的多选")]), _vm._v(" "), _c('mt-box-group', {
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  }, [_c('mt-cell-group', _vm._l((_vm.options1), function(item) {
    return _c('mt-radiobox', {
      key: item,
      ref: "cb",
      refInFor: true,
      attrs: {
        "name": item,
        "iconpattern": "hook"
      },
      scopedSlots: _vm._u([{
        key: "newline",
        fn: function(scope) {
          return (scope.checked) ? _c('div', {
            staticStyle: {
              "margin-top": "10px"
            }
          }, [_c('mt-textarea', {
            attrs: {
              "maxlength": "50"
            }
          })], 1) : _vm._e()
        }
      }])
    }, [_vm._v("\n                  " + _vm._s(item) + "\n                  ")])
  }))], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed8f7efa","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/radiobox.vue
// module id = 594
// module chunks = 0